<div
  class="chart-render"
  [class.with-drill-down]="isTemporalDrillAllowed && renderContext !== 'report_builder'"
>
  <div
    #chartContent
    class="chart-content"
    [class.extra-footer]="isFooterNeeded || (paging$ | async: this).isPaginated"
  ></div>
  <mode-facet-paging
    *ngIf="(paging$ | async: this).isPaginated"
    [currentPage]="(paging$ | async: this).currentPage"
    [totalPages]="(paging$ | async: this).totalPageCount"
    [facetsOnPage]="(paging$ | async: this).facetCountForPage"
    [totalFacetCount]="(paging$ | async: this).totalFacetCount"
    [pageSize]="(paging$ | async: this).pageSize"
    (pageChanged)="paginationSetPage($event)"
  ></mode-facet-paging>
</div>
